/**
 * Custom hook for managing data subscriptions
 */

import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { useTimeStore } from '../store/timeStore';
import { useClientStore } from '../store/clientStore';
import { useInvoiceStore } from '../store/invoiceStore';

// Whitelisted admin emails (must match authStore.js)
const ADMIN_EMAILS = [
  'michelle.armirola@gmail.com',
  'roseller@fusionict.com',
];

// Check if email is admin
const checkIsAdmin = (email) => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

export const useDataSubscriptions = () => {
  const user = useAuthStore((state) => state.user);
  const subscribeToEntries = useTimeStore((state) => state.subscribeToEntries);
  const subscribeToClients = useClientStore((state) => state.subscribeToClients);
  const subscribeToInvoices = useInvoiceStore((state) => state.subscribeToInvoices);

  useEffect(() => {
    if (!user) return;

    // Determine admin status synchronously from email
    const isAdmin = checkIsAdmin(user.email);

    console.log('User:', user.email, 'isAdmin:', isAdmin); // Debug log

    // Subscribe to all data streams
    // Admins can see all data, regular users see only their own
    const unsubscribeTime = subscribeToEntries(user.uid, isAdmin);
    const unsubscribeClients = subscribeToClients(user.uid, isAdmin);
    const unsubscribeInvoices = subscribeToInvoices(user.uid, isAdmin);

    // Cleanup subscriptions
    return () => {
      unsubscribeTime?.();
      unsubscribeClients?.();
      unsubscribeInvoices?.();
    };
  }, [user, subscribeToEntries, subscribeToClients, subscribeToInvoices]);
};
